import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/expertLine',
  redirect: 'expertLine',
  name: 'expertLine',
  component: Layout,
  children: [
    {
      path: 'expertLine',
      component: () => import('@/views/expertLine/index.vue'),
      name: 'expertLine',
      meta: {
        title: '课题申报管理',
        icon: 'tissue',
        requireAuth: true,
      }
    }
  ]
}

export default equipRouter
